(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-help-links"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
  var opener = e.target.closest('[data-phl-open]');
  if (opener) {
    var d = document.getElementById(opener.getAttribute('data-phl-open'));
    if (d) { if (d.showModal) d.showModal(); else d.setAttribute('open', ''); }
    return;
  }
  if (e.target.classList && e.target.classList.contains('phl-dialog') && e.target.close) {
    e.target.close();
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-perks"] && !Shopify.designMode) return;
  try {
    /* ---- helpful-guides dialogs ---- */
document.addEventListener('click', function (e) {
  var opener = e.target.closest('[data-pperk-open]');
  if (opener) {
    var d = document.getElementById(opener.getAttribute('data-pperk-open'));
    if (d) { if (d.showModal) d.showModal(); else d.setAttribute('open', ''); }
    return;
  }
  if (e.target.classList && e.target.classList.contains('pperk-guides__dialog') && e.target.close) {
    e.target.close();
  }
});

/* ---- <pdp-shipping-estimator> — live carrier rates for the viewed item ----
   Shopify has no "quote this product to this address" endpoint; /cart/shipping_rates.json
   only rates the current cart. So when the cart is EMPTY we temporarily add the selected
   variant, fetch rates, then clear it (safe — the cart was empty to begin with). If the
   cart already has items we just rate those. Guarded define so it coexists with any copy
   the theme already ships. */
if (!customElements.get('pdp-shipping-estimator')) {
  customElements.define('pdp-shipping-estimator', class extends HTMLElement {
    connectedCallback() {
      if (this._wired) return;
      this._wired = true;
      this.countryEl = this.querySelector('[data-country]');
      this.provinceField = this.querySelector('[data-province-field]');
      this.provinceEl = this.querySelector('[data-province]');
      this.zipEl = this.querySelector('[data-zip]');
      this.btn = this.querySelector('[data-estimate]');
      this.results = this.querySelector('[data-results]');
      this.statusEl = this.querySelector('[data-status]');
      if (this.countryEl) this.countryEl.addEventListener('change', () => this.syncProvince());
      if (this.btn) this.btn.addEventListener('click', (e) => { e.preventDefault(); this.estimate(); });
      if (this.zipEl) this.zipEl.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); this.estimate(); } });
      this.syncProvince();
    }

    // AU carrier rates need a province that MATCHES the postcode (mismatch or blank both 422),
    // so we derive the state from the postcode and only ask for country + postcode.
    auState(zip) {
      const n = parseInt(zip, 10);
      if (isNaN(n)) return '';
      if ((n >= 1000 && n <= 1999) || (n >= 2000 && n <= 2599) || (n >= 2619 && n <= 2899) || (n >= 2921 && n <= 2999)) return 'New South Wales';
      if ((n >= 200 && n <= 299) || (n >= 2600 && n <= 2618) || (n >= 2900 && n <= 2920)) return 'Australian Capital Territory';
      if ((n >= 3000 && n <= 3999) || (n >= 8000 && n <= 8999)) return 'Victoria';
      if ((n >= 4000 && n <= 4999) || (n >= 9000 && n <= 9999)) return 'Queensland';
      if (n >= 5000 && n <= 5799) return 'South Australia';
      if (n >= 6000 && n <= 6797) return 'Western Australia';
      if (n >= 7000 && n <= 7799) return 'Tasmania';
      if ((n >= 800 && n <= 899) || (n >= 900 && n <= 999)) return 'Northern Territory';
      return '';
    }

    syncProvince() {
      if (!this.countryEl || !this.provinceEl) return;
      if (this.countryEl.value === 'Australia') { this.provinceField.hidden = true; this.provinceEl.innerHTML = ''; return; }
      const opt = this.countryEl.options[this.countryEl.selectedIndex];
      let provinces = [];
      try { provinces = JSON.parse((opt && opt.getAttribute('data-provinces')) || '[]'); } catch (e) { /* none */ }
      if (!provinces.length) { this.provinceField.hidden = true; this.provinceEl.innerHTML = ''; return; }
      this.provinceField.hidden = false;
      this.provinceEl.innerHTML = provinces.map((p) => `<option value="${p[0]}">${p[1]}</option>`).join('');
    }

    variantId() {
      const input = document.querySelector('form[id^="ProductForm-"] input[name="id"]');
      if (input && /^\d+$/.test(input.value)) return input.value;
      const attr = this.getAttribute('data-variant-id');
      return attr && /^\d+$/.test(attr) ? attr : null;
    }

    async estimate() {
      const zip = (this.zipEl.value || '').trim();
      const country = this.countryEl.value;
      if (!zip) { this.zipEl.focus(); return; }
      const province = country === 'Australia'
        ? this.auState(zip)
        : (this.provinceField.hidden ? '' : this.provinceEl.value);
      if (country === 'Australia' && !province) {
        this.results.innerHTML = '';
        this.setStatus('Please enter a valid Australian postcode.', true);
        return;
      }

      this.setBusy(true);
      this.results.innerHTML = '';
      this.setStatus('');
      let tempAdded = false;
      try {
        const cart = await fetch('/cart.js', { headers: { accept: 'application/json' } }).then((r) => (r.ok ? r.json() : null)).catch(() => null);
        const empty = !!cart && cart.item_count === 0;
        const vid = this.variantId();
        if (empty && vid) {
          const add = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', accept: 'application/json' },
            body: JSON.stringify({ id: Number(vid), quantity: 1 }),
          });
          tempAdded = add.ok;
        }
        const res = await fetch('/cart/shipping_rates.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({ shipping_address: { zip, country, province } }),
        });
        if (!res.ok) throw new Error('rates ' + res.status);
        const data = await res.json();
        const rates = (data.shipping_rates || []).map((r) => ({
          name: r.presentment_name || r.name || 'Shipping',
          price: typeof r.price === 'number' ? r.price : parseFloat(r.price),
          currency: r.currency || null,
        }));
        this.render(rates, zip);
      } catch (e) {
        this.setStatus("We couldn't fetch live rates just now — your exact shipping is calculated at checkout.", true);
      } finally {
        if (tempAdded) { try { await fetch('/cart/clear.js', { method: 'POST', headers: { accept: 'application/json' } }); } catch (e) { /* best effort */ } }
        this.setBusy(false);
      }
    }

    render(rates, zip) {
      if (!rates.length) {
        this.setStatus("We don't have a live rate for that address — it'll be calculated at checkout.", true);
        return;
      }
      rates.sort((a, b) => a.price - b.price);
      const money = (r) => (r.price === 0 ? 'FREE' : '$' + r.price.toFixed(2) + (r.currency ? ' ' + r.currency : ''));
      this.results.innerHTML =
        rates.map((r) => `<div class="pperk-ship__rate"><span class="pperk-ship__name">${this.esc(r.name)}</span><span class="pperk-ship__price">${money(r)}</span></div>`).join('') +
        `<p class="pperk-ship__note">Live rate for this item to ${this.esc(zip)}. Final price is confirmed at checkout.</p>`;
    }

    esc(s) { return String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])); }
    setBusy(b) { if (!this.btn) return; this.btn.disabled = b; this.btn.textContent = b ? 'Getting rates…' : this.btn.dataset.label; }
    setStatus(msg, err) { if (!this.statusEl) return; this.statusEl.textContent = msg || ''; this.statusEl.hidden = !msg; this.statusEl.classList.toggle('pperk-ship__error', !!err); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
